import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import NoRoute from '../../components/TranRoutes/NoRoute/NoRoute'
import RouteFilters from '../../components/TranRoutes/RouteFilters'
import RoutesBlock from '../../components/TranRoutes/RoutesBlock'
import { setCurrentTransport } from '../../redux/slices/select'
import { tranRoutesSelector } from '../../redux/slices/tranRoutes'
import { fetchDayTypes } from '../../redux/thunks/select'

const TranRoutes = () => {
  const { route_id } = useSelector(tranRoutesSelector)

  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(fetchDayTypes())

    return () => {
      dispatch(setCurrentTransport())
    }
  }, [dispatch])

  return (
    <div className="tran_routes_page wrapper_1440">
      <RouteFilters />
      {route_id ? <RoutesBlock /> : <NoRoute />}
    </div>
  )
}

export default TranRoutes
